<template>
  <v-autocomplete
    v-model="teamIds"
    :items="teams"
    :loading="loading"
    :search-input.sync="searchInput"
    label="Teams"
    item-text="name"
    item-value="id"
    class="app-select"
    multiple
    hide-details
    outlined
    dense
    chips
    @change="searchInput = ''"
  >
    <template #selection="{ item }">
      <CommonChip close @click:close="removeHandler(item.id)">
        {{ item.name }}
      </CommonChip>
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import Team from '@/bundles/Teams/models/Team';
import { teamsService } from '@/bundles/Teams/factory/teamsFactory';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default Vue.extend({
  name: 'TeamsSelect',

  components: { CommonChip },

  props: {
    value: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },

  data: (): { searchInput: string; teams: Team[]; loading: boolean } => ({
    searchInput: '',
    teams: [],
    loading: false,
  }),

  computed: {
    teamIds: {
      get (): number[] {
        return this.value;
      },
      set (value: number[]) {
        this.$emit('input', value);
      },
    },
  },

  async created () {
    try {
      this.loading = true;
      this.teams = await teamsService.myTeams();
    } catch (error) {
      this.addNotification({ ...error, status: 0 });
    } finally {
      this.loading = false;
    }
  },

  methods: {
    removeHandler (id: number) {
      this.$emit('input', this.teamIds.filter((teamId) => teamId !== id));
    },
  },
});
</script>
